import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getSubAccounts } from '../../services/subAccountsService';
import {
  editingSubAccountState,
  loadingSubAccountsState,
  searchSubAccountState,
  subAccountsPageState,
  subAccountsState,
  updateSubAccountsState,
} from '../../storage/subAccounts';
import { SubAccount } from '../../types/subAccount';
import { PaginatedProvider } from './PaginatedProvider';

function SubAccountsProvider() {
  const setPaginatedSubAccounts = useSetRecoilState(subAccountsState);
  const updateSubAccounts = useRecoilValue(updateSubAccountsState);
  const resetUpdateSubAccounts = useResetRecoilState(updateSubAccountsState);
  const resetEditingSubAccount = useResetRecoilState(editingSubAccountState);
  const setLoadingSubAccounts = useSetRecoilState(loadingSubAccountsState);

  return (
    <PaginatedProvider<SubAccount>
      searchState={searchSubAccountState}
      pageState={subAccountsPageState}
      getPaginated={getSubAccounts}
      setPaginated={setPaginatedSubAccounts}
      onSearchChange={() => {}}
      onUpdateFinish={() => {
        resetUpdateSubAccounts();
        resetEditingSubAccount();
      }}
      setLoading={setLoadingSubAccounts}
      update={updateSubAccounts}
    />
  );
}

export default SubAccountsProvider;
